// extracted by mini-css-extract-plugin
export default {"initialsColors":"nNn+zWEBwjBhxbEQ7xTXqQ=="};